const SW_EVENT_NAME = "sw-build-update"

export const dispatchSWUpdateEvent = () => {
  window.dispatchEvent(new CustomEvent(SW_EVENT_NAME, { detail: { type: "update" } }));
}

export const createSWRouterMiddleware = (router) => {
  let isUpdate = false;

  const listenToSWUpdate = () => {
    const { detail } = event;
    if (detail.type === "update") {
      isUpdate = true;
      console.log("New content is available, refresh will happen with next navigation.");
    }
  };

  const init = () => {
    window.removeEventListener(SW_EVENT_NAME, listenToSWUpdate);

    router.beforeEach((to, _, next) => {
      if (isUpdate) {
        isUpdate = false;
        window.location.href = window.location.origin + to.fullPath;
      } else {
        next();
      }
    });

    window.addEventListener(SW_EVENT_NAME, listenToSWUpdate);

    return router;
  }


  return init();
}
